import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FreeEvaluationUsersListComponent } from 'src/app/shared/components/free-evaluation-users-list/free-evaluation-users-list.component';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

@NgModule({
    declarations: [
        FreeEvaluationUsersListComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        PipesModule,
        MatTooltipModule
    ],
    exports: [
        FreeEvaluationUsersListComponent
    ]
})
export class FreeEvaluationUsersListModule {
}
